import { render, staticRenderFns } from "./CampaignReport.vue?vue&type=template&id=604b6d28&scoped=true&"
import script from "./CampaignReport.vue?vue&type=script&lang=js&"
export * from "./CampaignReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604b6d28",
  null
  
)

export default component.exports